import { useEffect, useId, useRef } from 'react'
import { Icon } from '@iconify/react'
import { MascotCareCheckout } from './MascotCareCheckout'
import { MASCOT_CARE_OPTIONS, type MascotCareBenefit } from './mascot-care-options'
import styles from './MascotGame.module.css'

export function MascotCarePurchaseButton({
  benefit,
  disabled,
  onPurchase,
}: {
  benefit: MascotCareBenefit
  disabled: boolean
  onPurchase?: (benefit: MascotCareBenefit) => void
}) {
  if (!onPurchase) return null
  return (
    <button
      type="button"
      className={styles.carePurchaseButton}
      disabled={disabled}
      onClick={() => onPurchase(benefit)}
    >
      <Icon icon="mdi:cart-plus" aria-hidden /> {MASCOT_CARE_OPTIONS[benefit].button} · R$
      10,00
    </button>
  )
}

export function MascotCarePurchaseDialog({
  onClose,
  ...props
}: {
  campaignId: number
  benefit: MascotCareBenefit
  energy: number
  disabled: boolean
  onPaid: () => Promise<void>
  onClose: () => void
}) {
  const dialog = useRef<HTMLDialogElement>(null)
  const titleId = useId()
  useEffect(() => {
    const element = dialog.current
    const previous =
      document.activeElement instanceof HTMLElement ? document.activeElement : null
    element?.showModal()
    return () => {
      element?.close()
      previous?.focus({ preventScroll: true })
    }
  }, [])
  return (
    <dialog
      ref={dialog}
      className={styles.carePurchaseDialog}
      aria-labelledby={titleId}
      onCancel={(event) => {
        event.preventDefault()
        event.stopPropagation()
        onClose()
      }}
    >
      <header>
        <h2 id={titleId}>Cuidar do mascote</h2>
        <button
          type="button"
          className={styles.iconButton}
          onClick={onClose}
          aria-label="Fechar compra do mascote"
        >
          <Icon icon="mdi:close" />
        </button>
      </header>
      <MascotCareCheckout {...props} />
    </dialog>
  )
}
